import { localCartKey } from "../common";
import { decrypt, encrypt } from "./EncrHelper";
import _ from "lodash";

export const addToCart = (updateSessionStorage, cartItem) => {
  if (cartItem.isBogoFree == null) {
    cartItem.isBogoFree = false;
  }
  // Ensure product object and slug are present
  if (!cartItem.product) cartItem.product = {};
  if (!cartItem.product.slug && cartItem.slug)
    cartItem.product.slug = cartItem.slug;
  const encryptedCart = localStorage.getItem(localCartKey);
  let plainTextCart = encryptedCart ? JSON.parse(decrypt(encryptedCart)) : [];
  if (!plainTextCart) plainTextCart = [];

  let existingCartItemIndex = plainTextCart.findIndex(
    (i) =>
      i.product_id === cartItem.product_id &&
      _.isMatch(cartItem.options, i.options) &&
      i.isBogoFree === cartItem.isBogoFree
  );
  if (existingCartItemIndex !== -1)
    plainTextCart[existingCartItemIndex].qty += cartItem.qty;
  else plainTextCart.push(cartItem);

  updateSessionStorage(localCartKey, plainTextCart);
};

export const incQuantity = (updateSessionStorage, cartItem, qty) => {
  if (cartItem.isBogoFree == null) {
    cartItem.isBogoFree = false;
  }
  if (!cartItem.product) cartItem.product = {};
  if (!cartItem.product.slug && cartItem.slug)
    cartItem.product.slug = cartItem.slug;
  const encryptedCart = localStorage.getItem(localCartKey);
  let plainTextCart = encryptedCart ? JSON.parse(decrypt(encryptedCart)) : [];
  if (!plainTextCart) plainTextCart = [];

  let existingCartItemIndex = plainTextCart.findIndex(
    (i) =>
      i.product_id === cartItem.product_id &&
      _.isMatch(cartItem.options, i.options) &&
      i.isBogoFree === cartItem.isBogoFree
  );
  if (existingCartItemIndex !== -1) {
    plainTextCart[existingCartItemIndex].qty += qty;
    updateSessionStorage(localCartKey, plainTextCart);
  }
};

export const removeFromCart = (updateSessionStorage, cartItem) => {
  if (cartItem.isBogoFree == null) {
    cartItem.isBogoFree = false;
  }
  const encryptedCart = localStorage.getItem(localCartKey);
  let plainTextCart = encryptedCart ? JSON.parse(decrypt(encryptedCart)) : [];
  if (!plainTextCart) plainTextCart = [];

  let existingCartItemIndex = plainTextCart.findIndex(
    (i) =>
      i.product_id === cartItem.product_id &&
      _.isMatch(cartItem.options, i.options) &&
      i.isBogoFree === cartItem.isBogoFree
  );
  if (existingCartItemIndex !== -1) {
    plainTextCart.splice(existingCartItemIndex, 1);
  }

  updateSessionStorage(localCartKey, plainTextCart);
};

export const clearLocalCart = (updateSessionStorage) => {
  updateSessionStorage(localCartKey, []);
};

export const setCart = (updateSessionStorage, plainTextCart) => {
  plainTextCart = plainTextCart.map((cartItem) => {
    if (cartItem.isBogoFree == null) {
      cartItem.isBogoFree = false;
    }
    if (!cartItem.product) cartItem.product = {};
    if (!cartItem.product.slug && cartItem.slug)
      cartItem.product.slug = cartItem.slug;
    return cartItem;
  });
  localStorage.removeItem(localCartKey);
  updateSessionStorage(localCartKey, plainTextCart);
};

export const getInitialCart = () => {
  const encryptedCart = localStorage.getItem(localCartKey);
  let plainTextCart = encryptedCart ? JSON.parse(decrypt(encryptedCart)) : [];
  if (!plainTextCart) plainTextCart = [];
  return plainTextCart;
};
